import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BusinessService } from '../models/business-service.model';
import { BusinessFeesService } from '../services/business-fees.service';
var EditFeeComponent = /** @class */ (function () {
    function EditFeeComponent(_businessFeeService, _matDialogRef, _snackBar, data) {
        this._businessFeeService = _businessFeeService;
        this._matDialogRef = _matDialogRef;
        this._snackBar = _snackBar;
        this.isNew = false;
        this.isLoading = false;
        this.feeTypes = new Array();
        this.feeBasisVals = ['Per Use', 'Hourly', '12 Hour',
            '24 Hour', 'Weekly', 'Monthly', 'Annual', 'No Fee', 'Fee Not Disclosed'];
        this.aircraftTypes = new Array();
        this.fee = data.fee || new BusinessService();
        this.isNew = data.isNew || false;
        this.busID = data.busID;
        this.originalFee = Object.assign(new BusinessService(), data.fee);
        this.itemsToChange = new Set();
        this.selectedDescription = this.fee.description;
        this.selectedFeeBasis = BusinessService.formatFeeBasis(this.fee.feeBasis);
        // this.selectedFee = this.fee.fee ? this.fee.fee.toFixed(2) : '0.00';
        if (this.fee.fee) {
            if (Number.isInteger(this.fee.fee)) {
                this.selectedFee = this.fee.fee.toFixed(0);
            }
            else {
                this.selectedFee = this.fee.fee.toFixed(2);
            }
        }
        else {
            this.selectedFee = '0';
        }
        this.selectedNote = this.fee.serviceNote ? this.fee.serviceNote : '';
        this.selectedAircraftType = this.fee.aircraftType;
        this.selectedWaiverFuelQty = this.fee.waiverFuelQty ? this.fee.waiverFuelQty.toString() : '';
        if (this.isNew) {
            this.selectedWaiver = false;
        }
        else {
            this.selectedWaiver = this.fee.waiver;
        }
    }
    EditFeeComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, feeControl, feeBasisControl;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this._matDialogRef.backdropClick().subscribe(function () {
                            _this.close({ cancelBtnClicked: true });
                        });
                        this.formGroup = new FormGroup({
                            description: new FormControl(this.selectedDescription, [Validators.required]),
                            feeBasis: new FormControl({ value: this.selectedFeeBasis, disabled: false }, [Validators.required]),
                            fee: new FormControl({ value: this.selectedFee, disabled: false }, [Validators.min(.01), Validators.maxLength(6),
                                Validators.pattern('\\d*(\\.\\d\\d)?$')]),
                            note: new FormControl(this.selectedNote, [Validators.maxLength(500)]),
                            aircraftType: new FormControl(this.selectedAircraftType, [Validators.required]),
                            waiver: new FormControl(this.selectedWaiver, [Validators.required]),
                            waiverFuelQty: new FormControl(this.selectedWaiverFuelQty, [Validators.maxLength(6),
                                Validators.pattern('\\d+')]),
                            feeRadio: new FormControl(this.selectedFeeRadio, [Validators.required]),
                        });
                        _a = this;
                        return [4 /*yield*/, this._businessFeeService.getFeeTypes()];
                    case 1:
                        _a.feeTypes = _d.sent();
                        _b = this;
                        _c = this.sortAircraftType;
                        return [4 /*yield*/, this._businessFeeService.getAircraftTypes()];
                    case 2:
                        _b.aircraftTypes = _c.apply(this, [_d.sent()]);
                        this.aircraftTypes.splice(this.aircraftTypes.length - 1, 1);
                        if (this.isNew) {
                            feeControl = this.formGroup.get('fee');
                            feeControl.disable();
                            feeBasisControl = this.formGroup.get('feeBasis');
                            feeBasisControl.disable();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    EditFeeComponent.prototype.feeChargedClick = function () {
        var feeControl = this.formGroup.get('fee');
        if (feeControl.value <= 1) {
            this.formGroup.patchValue({ fee: 1 });
        }
        var feeBasisControl = this.formGroup.get('feeBasis');
        if (feeBasisControl.value === 'No Fee' || feeBasisControl.value === 'Fee Not Disclosed') {
            this.formGroup.patchValue({ feeBasis: null });
        }
        feeControl.enable();
        feeBasisControl.enable();
    };
    EditFeeComponent.prototype.feeNotChargedClick = function () {
        this.formGroup.patchValue({ fee: null });
        this.formGroup.patchValue({ feeBasis: 'No Fee' });
        var feeControl = this.formGroup.get('fee');
        feeControl.disable();
        var feeBasisControl = this.formGroup.get('feeBasis');
        feeBasisControl.disable();
    };
    EditFeeComponent.prototype.feeNotDisclosedClick = function () {
        this.formGroup.patchValue({ fee: null });
        this.formGroup.patchValue({ feeBasis: 'Fee Not Disclosed' });
        var feeControl = this.formGroup.get('fee');
        feeControl.disable();
        var feeBasisControl = this.formGroup.get('feeBasis');
        feeBasisControl.disable();
    };
    EditFeeComponent.prototype.feeBasisChanged = function () {
        if (this.selectedFeeBasis === 'No Fee') {
            this.formGroup.patchValue({ feeRadio: 'FeeNotCharged' });
            this.feeNotChargedClick();
        }
        if (this.selectedFeeBasis === 'Fee Not Disclosed') {
            this.formGroup.patchValue({ feeRadio: 'FeeNotDisclosed' });
            this.feeNotDisclosedClick();
        }
    };
    EditFeeComponent.prototype.sortAircraftType = function (aircraftTypes) {
        return aircraftTypes.sort(function (a, b) { return +(b === 'All Aircraft') - +(a === 'All Aircraft')
            || +(b === 'Single-Engine Piston') - +(a === 'Single-Engine Piston')
            || +(b === 'Multi-Engine Piston') - +(a === 'Multi-Engine Piston')
            || +(b === 'Single-Engine Turboprop') - +(a === 'Single-Engine Turboprop')
            || +(b === 'Multi-Engine Turboprop') - +(a === 'Multi-Engine Turboprop')
            || +(b === 'Small Jet (up to 16K lbs.)') - +(a === 'Small Jet (up to 16K lbs.)')
            || +(b === 'Medium Jet (16K – 40K lbs.)') - +(a === 'Medium Jet (16K – 40K lbs.)')
            || +(b === 'Large Jet (40K lbs. and up)') - +(a === 'Large Jet (40K lbs. and up)')
            || +(a > b) || -(a < b); });
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditFeeComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        res = void 0;
                        this.fee.description = this.formGroup.get('description').value;
                        this.fee.fee = this.formGroup.get('fee').value;
                        this.fee.feeBasis = BusinessService.parseFeeBasis(this.formGroup.get('feeBasis').value);
                        this.fee.aircraftType = this.formGroup.get('aircraftType').value;
                        this.fee.serviceNote = this.formGroup.get('note').value;
                        this.fee.waiver = this.formGroup.get('waiver').value;
                        this.fee.waiverFuelQty = this.formGroup.get('waiverFuelQty').value;
                        if (!this.isNew) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._businessFeeService.createBusinessService(this.busID, this.fee)];
                    case 1:
                        res = _a.sent();
                        this.fee = BusinessService.parse(res);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._businessFeeService.updateBusinessService(this.busID, this.fee.serviceId, this.fee)];
                    case 3:
                        res = _a.sent();
                        Object.assign(this.fee, BusinessService.parse(res));
                        this.fee = BusinessService.parse(res);
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, fee: this.fee });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditFeeComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditFeeComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.fee, this.originalFee);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditFeeComponent;
}());
export { EditFeeComponent };
